import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__svg_provider_js_ad72b583__ from "../_svg/provider.js";
const ProviderIcon = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((properties, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__svg_provider_js_ad72b583__["default"], {
        ...properties,
        ref: reference
    }));
ProviderIcon.displayName = 'ProviderIcon';
export { ProviderIcon };

//# sourceMappingURL=provider.js.map